<template>
  <Transition name="fade">
    <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center px-4">
      <!-- Backdrop -->
      <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="close"></div>
      
      <!-- Modal -->
      <div class="relative bg-white/10 backdrop-blur-md text-white rounded-xl p-8 max-w-lg w-full animate-float">
        <button 
          @click="close"
          class="absolute top-4 right-4 text-white/80 hover:text-white"
        >
          ✕
        </button>
        
        <h2 class="text-2xl font-bold mb-6 gradient-text">About Payment Reminder</h2>
        
        <div class="space-y-4">
          <div>
            <h3 class="text-xl font-semibold mb-2">Development Team</h3>
            <p>Created with ❤️ by the Ember Sphere Team</p>
          </div>
          <div>
            <h3 class="text-xl font-semibold mb-2">Version</h3>
            <p>1.0.0 Beta</p>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes float {
  0% { transform: translateY(20px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}

.animate-float {
  animation: float 0.4s ease-out forwards;
}
</style>
